<template>
  <div id="bsTableList" class="h100vh-140">
    <div class="h100vh-140">
      <ejs-grid
        ref="grid"
        :dataSource="BSDeviceData"
        height="calc(100% - 0px)"
        allowReordering="true"
        allowResizing="true"
        allowExcelExport="true"
        allowTextWrap="true"
        :selectionSettings='selectionOptions'
      >
        <e-columns>
          <e-column type="checkbox" width="40" textAlign="center"></e-column>
          <e-column
            field="id"
            :headerText="id"
            width="70"
            textAlign="Center"
          ></e-column>
          <e-column
            field="name"
            :headerText="deviceName"
            width="120"
            textAlign="Center"
          ></e-column>
          <e-column
            field="ip"
            :headerText="ip"
            width="100"
            textAlign="Center"
          ></e-column>
          <e-column
            field="runningVersion"
            :headerText="deviceRunVersion"
            width="120"
            textAlign="Center"
            :template="detailTemplate"
          ></e-column>
          <e-column
            field="storeVersion"
            :headerText="deviceSaveVersion"
            width="120"
            textAlign="Center"
            :template="detailStoreTemplate"
          ></e-column>
          <e-column
            field="displaySoftwareVersion"
            :headerText="deviceLocalVersion"
            width="200"
            textAlign="Center"
          ></e-column>
          <e-column
            field="deviceType"
            :headerText="deviceType"
            width="100"
            textAlign="Center"
            :valueAccessor="deviceTypeFormatter"
          ></e-column>
          <e-column
            field="createTime"
            :headerText="deviceCreateTime"
            width="120"
            textAlign="Center"
            type="date"
            format="yyyy-MM-dd HH:mm:ss"
          ></e-column>
          <e-column
            field="synSuccessTime"
            :headerText="deviceSynSuccessTime"
            width="120"
            textAlign="Center"
            type="date"
            format="yyyy-MM-dd HH:mm:ss"
          ></e-column>
        </e-columns>
      </ejs-grid>
      <ejs-pager
        ref="devpager"
        @click="getDeviceListData()"
        :currentPage="page.pageNo"
        :pageSize="page.pageSize"
        :totalRecordsCount="page.totalCount"
        :pageCount="page.pageCount"
      ></ejs-pager>
    </div>
    <CustomDialog
      ref="queryRunVersionRef"
      :element="dialog.eleQueryRunVersion"
      :styles="dialog.styles"
    >
      <template v-slot:dialog-content>
        <QueryRunVersion ref="queryRunVersionContent"></QueryRunVersion>
      </template>
    </CustomDialog>
    <CustomDialog
      ref="queryStoreVersionRef"
      :element="dialog.eleQueryStoreVersion"
      :styles="dialog.styles"
    >
      <template v-slot:dialog-content>
        <QueryStoreVersion ref="queryStoreVersionContent"></QueryStoreVersion>
      </template>
    </CustomDialog>
    <CustomDialog
      ref="confirmDel"
      :element="dialog.delDeviceDialog"
      :styles="dialog.styles2"
    >
       <template v-slot:dialog-content>
        <DelConfirm ref="delConfirm"></DelConfirm>
      </template>
    </CustomDialog>
  </div>
</template>

<script>
import { EventBus } from "../../../../plugins/eventBus";
// import socketInstance from "../../../../plugins/stompSock";
import detailTemplate from "./RunDetailTemplate";
import detailStoreTemplate from "./StoreDetailTemplate";
import CustomDialog from "../../../common/CustomDialog";
import QueryRunVersion from "./QueryRunVersion";
import QueryStoreVersion from "./QueryStoreVersion";
import DelConfirm from "./DelConfirm";

export default {
  name: "BSTable",
  components: {
    EventBus,
    detailTemplate,
    detailStoreTemplate,
    CustomDialog,
    QueryRunVersion,
    QueryStoreVersion,
    DelConfirm
    // socketInstance,
  },
  mounted() {
    // this.websocketInitQuery();
    this.getDeviceListData();
    this.$loading.showLoadding(this.$t("SubscriberIms.waitTip"));
  },
  data() {
    return {
      selectionOptions: { type: 'Multiple' },
      searchValue: "", //模糊搜索条件
      BSDeviceData: [], // 基站设备数据源
      page: {
        // 分页数据
        pageNo: 1,
        pageSize: 20,
        totalCount: 0,
        pageCount: 10,
      },
      deviceState: "状态",
      id: this.$t("Observe.neId"),
      deviceName: this.$t("Alarm.equipmentName"),
      deviceRunVersion: this.$t("Software.runversion"),
      deviceSaveVersion: this.$t("Software.storeversion"),
      ip:this.$t("Software.ipAddress"),
      deviceLocalVersion: this.$t("DeployManagement.localVersion"),
      deviceType: this.$t("Alarm.equipmentType"),
      deviceCreateTime: this.$t("Software.td_createTime"),
      deviceSynSuccessTime: this.$t("DeployManagement.synSuccessTime"),
      deviceTypeMap: new Map() // 设备码和类型对应关系
        .set(10001, this.$t("Topo.devEPC"))
        .set(10002, this.$t("Topo.devhytalkPro"))
        .set(10003, this.$t("Topo.devMCS"))
        .set(10004, this.$t("Topo.deveNodeB"))
        .set(10005, this.$t("Topo.deveNodeBIOPS"))
        .set(10006, this.$t("Topo.deviBS"))
        .set(10007, this.$t("Topo.deviBSB"))
        .set(10008, this.$t("Topo.devODBBU"))
        .set(10009, this.$t("Topo.devgNB"))
        .set(10010, this.$t("Topo.devhytalk")),
      // websocketSettingQuery: [
      //   {
      //     topic: "/topic/VmQueryVersionServer",
      //     clientId: "vm",
      //     callback: this.websocketCallbackQuery,
      //   },
      // ],
      dialog: {
        eleQueryRunVersion: {
          target: this.$refs.queryRunVersionContent,
          refName: "queryRunVersionContent",
          buttonGroup: [
            {
              click: this.closeQueryRunVersion,
              buttonModel: { content: this.$t("Common.cancel") },
            },
          ],
          title: this.$t("Software.runversion"),
          isClose: true,
        },
        eleQueryStoreVersion: {
          target: this.$refs.queryStoreVersionContent,
          refName: "queryStoreVersionContent",
          buttonGroup: [
            {
              click: this.closeStoreRunVersion,
              buttonModel: { content: this.$t("Common.cancel") },
            }
          ],
          title: this.$t("Software.storeversion"),
          isClose: true,
        },
        delDeviceDialog: {
          target: this.$refs.delConfirm,
          refName: "delConfirm",
          buttonGroup: [
            {
              click: this.closeDelDevice,
              buttonModel: { content: this.$t("Common.cancel") },
            },
            {
              click: this.delDev2Confirm,
              buttonModel: { content: this.$t("Common.confirm") },
            }
          ],
          title: 'Warning',
          isClose: true,
        },
        styles: {
          width: "65%",
          height: "80%",
          visible: false,
          model: true,
        },
        styles2: {
          width: "25%",
          height: "30%",
          visible: false,
          model: true,
        },
      },
      detailTemplate(args) {
        return {
          template: detailTemplate,
        };
      },
      detailStoreTemplate(args) {
        return {
          template: detailStoreTemplate,
        };
      },
    };
  },

  methods: {
    // websocketInitQuery() {
    //   socketInstance.init(this.websocketSettingQuery);
    // },
    websocketCallbackQuery(msg) {
      let tableDataTemp = JSON.parse(JSON.stringify(this.BSDeviceData));
      console.log("vmQueryVersionServer:>>>>>", msg);
      if (msg) {
        const data = JSON.parse(msg.body);
        for (var i = 0; i < tableDataTemp.result.length; i++) {
          if (data.neId == tableDataTemp.result[i].id) {
            tableDataTemp.result[i].runningVersion =
              data.Data[0].currentVersion;
            tableDataTemp.result[i].storeVersion = data.Data[0].backupVersion;
          }
        }
        this.BSDeviceData = null;
        this.BSDeviceData = JSON.parse(JSON.stringify(tableDataTemp));
          this.BSDeviceData.result.forEach(element => {
            if(element.equipmentIPList !=null && element.equipmentIPList.length >0){
                         element.ip = element.equipmentIPList[0].ip;
                }
            });
      }
    },
    // 初始化表格数据
    getDeviceListData() {
      const This = this;
      This.page.pageNo = This.$refs.devpager.ej2Instances.currentPage;
      This.$axios
        .get(
          `/lte/ems/env/devPage?pageNo=${This.page.pageNo}&pageSize=${This.page.pageSize}&name=${This.searchValue}`
        )
        .then((response) => {
          if (
            response.status === 200 &&
            response.data.errorCode === "SUCCESS"
          ) {
            if (
              response.data !== undefined ||
              response.data.resultVal !== undefined
            ) {
              This.BSDeviceData = response.data.resultVal;
              This.page.totalCount = response.data.resultVal.totalCount;
              if (
                undefined != This.BSDeviceData.result &&
                null !== This.BSDeviceData.result
              ) {
                let idList = [];
                This.BSDeviceData.result.filter((item) => {
                  idList.push(item.id);
                });
                // setTimeout(() => {
                //   this.queryVersion(idList);
                // }, 1000);
                This.BSDeviceData.result.forEach(element => {
                  if(element.equipmentIPList !=null && element.equipmentIPList.length >0){
                         element.ip = element.equipmentIPList[0].ip;
                  }
                });
              }
            }
          } else {
            EventBus.$emit("toast", {
              type: "error",
              content: response.data.errorString,
            });
          }
          this.$loading.hideLoadding();
        });
    },
    queryVersion(idList) {
      const params = idList;
      this.$axios
        .post(`/lte/ems/verquery_new/queryRunVerAction`, params)
        .then((response) => {});
    },
    // 模糊搜索
    search(searchValue) {
      console.log("bsTable搜索方法");
      const This = this;
      if (searchValue !== "") {
        This.page.pageNo = 1;
      } else {
        This.page.pageNo = This.$refs.devpager.ej2Instances.currentPage;
      }
      const nameParam=encodeURIComponent(searchValue)
      This.$axios
        .get(
          `/lte/ems/env/devPage?pageNo=${This.page.pageNo}&pageSize=${This.page.pageSize}&name=${nameParam}`
        )
        .then((response) => {
          if (
            response.data === undefined ||
            response.data.resultVal === undefined
          ) {
            return;
          }
          if (
            response.status === 200 &&
            response.data.errorCode === "SUCCESS"
          ) {
            This.BSDeviceData = response.data.resultVal;
            This.BSDeviceData.result.forEach(element => {
            if(element.equipmentIPList !=null && element.equipmentIPList.length >0){
                         element.ip = element.equipmentIPList[0].ip;
                }
            });

            This.page.totalCount = response.data.resultVal.totalCount;
          } else {
            EventBus.$emit("toast", {
              type: "error",
              content: response.data.errorString,
            });
          }
         this.$loading.hideLoadding();
        });
    },
    // 格式化设备类型
    deviceTypeFormatter(field, devData) {
      return this.deviceTypeMap.get(devData["typeCode"]);
    },
    // 判断运行版本是否为空
    runVersionFormatter(grids, data) {
      if (
        data.runningVersion === undefined ||
        data.runningVersion === null ||
        data.runningVersion === ""
      ) {
        return "--";
      }
    },
    // 判断存储版本是否为空
    storeVersionFormatter(grids, data) {
      if (
        data.storeVersion === undefined ||
        data.storeVersion === null ||
        data.storeVersion === ""
      ) {
        return "--";
      }
    },
        // 删除确认
    delDeviceConfirm() {
     const devIdVec = this.getCheckedValues(true);
      if(devIdVec.length >= 1){
         this.delDev2Confirm();
      }

       if (devIdVec.length ==0) {
        EventBus.$emit("toast", {
          type: "warning",
          content: this.$t("Topo.pleaseSelectOne"),
        });
        return false;
      }

    },
    delDev2Confirm(){
         const devIdVec = this.getCheckedValues(true);
        if (devIdVec) {
          this.$layer.confirm({
            msg: this.$t("Topo.sureDel"),
            btn1: {
              msg: this.$t("Topo.cancel"),
            },
            btn2: {
              msg: this.$t("Topo.confirm"),
              func: this.delDev,
            },
          });
        }
    },
    // 删除操作
    async delDev() {
      //const devIdVec = this.getCheckedValues(true);
      const success = [];
      const fail = [];
      const checkedData = this.getCheckedData(true);
      for(let i =0;i<checkedData.length;i++){
          let devId = JSON.stringify(checkedData[i].id);
          let devName = JSON.stringify(checkedData[i].deviceName);

        //先验证此网元下有没有非实时任务，有不能删除
        if(checkedData && checkedData.length > 0){
          let taskExist = false;
          let taskExistNeId = '';
          let taskExistNeName = '';
          const neArray = checkedData.map(e => ({neId: e.id + '', neName: e.name, typeCode: e.typeCode}));
          await this.axios.post('/lte/pm/currenttime/taskmanagement/getRealTimeTaskNeListDataFromNe.html', {
            neArray: neArray
          }).then((response) => {
            if (response.data === undefined) {
              return;
            }
            if (response.status === 200 && response.data.errorCode === "SUCCESS") {
              if(response.data.resultVal && response.data.resultVal.length > 0){
                taskExist = true;
                taskExistNeName = response.data.resultVal[0].meter_ne_name;
                taskExistNeId = response.data.resultVal[0].meter_ne;
              }
            }
          })
          if(taskExist){
            EventBus.$emit("toast", {
              type: "warning",
              content: this.$t("Topo.delNeFailedForRealTaskMsg").replace('{0}', taskExistNeId + '-' + taskExistNeName),
            });
            return;
          }
        }

           await this.axios.get(`/lte/ems/env/deleteDev/${devId}`).then((response) => {
                    if (response.data === undefined) {
                      return;
                    }
                    if (response.status === 200 && response.data.errorCode === "SUCCESS") {

                      // EventBus.$emit("toast", {
                      //   type: "success",
                      //   content: this.$t("Topo.delSuccess"),
                      // });
                      success.push(devName);
                      return;
                    } else {
                      EventBus.$emit("toast", {
                        type: "error",
                        content: response.data.errorString + " : "+devName,
                      });
                      fail.push(devName);
                    }
                  });
      }
      if(success.length>0){
            EventBus.$emit("toast", {
                        type: "success",
                        content: this.$t("Topo.delSuccess"),
            });
      }
      this.getDeviceListData();
      this.closeDelDevice();
    },
    getCheckedValues(selectOnly = false) {
      const deviceID = [];
      const checkedData = this.getCheckedData(selectOnly);
      for (let i = 0; i < checkedData.length; i++) {
        deviceID.push(checkedData[i].id);
      }
      return deviceID.length === 0 ? false : deviceID;
    },
    // 获取选中数据, 前台校验选中数量
    getCheckedData(selectOnly) {
      const selectedRecords = this.$refs.grid.getSelectedRecords();
      if (selectedRecords.length < 1) {
        EventBus.$emit("toast", {
          type: "warning",
          content: this.$t("Topo.pleaseSelect"),
        });
        return false;
      }
      if (selectedRecords.length > 1 && !selectOnly) {
        EventBus.$emit("toast", {
          type: "warning",
          content: this.$t("Topo.pleaseSelectOne"),
        });
        return false;
      }
      return selectedRecords;
    },
    rowSelecting(args){
        const selectedRecords = this.$refs.grid.getSelectedRecords();
        return selectedRecords;
      },
    // 同步版本
    synVersion() {
      const versionInfo = this.getCheckedValues(true);
      for (let i = 0; i < versionInfo.length; i++) {
        let bsId = JSON.stringify(versionInfo[i]);
        if (bsId !== undefined) {
          this.axios.get(`/lte/ems/env/synVersion/${bsId}`).then((response) => {
            if (response.data === undefined) {
              return;
            }
            if (
              response.status === 200 &&
              response.data.errorCode === "SUCCESS"
            ) {
              this.getDeviceListData();
              EventBus.$emit("toast", {
                type: "success",
                content: this.$t("Alarm.syncSuccess"),
              });
              return;
            } else {
              EventBus.$emit("toast", {
                type: "error",
                content: response.data.errorString,
              });
            }
          });
        }
      }
    },
    //更改GPS
    changeGPS() {
      const devIdVec = this.getCheckedValues(true);
      let devId = JSON.stringify(devIdVec[0]);
      if (devId !== undefined) {
        this.$parent.$refs.gpsMap.bsDeviceId = devId;
        this.$parent.$refs.gpsMap.bsEquipment =
          this.$refs.grid.getSelectedRecords();
        this.$parent.$refs.gpsMap.qryAllPoint();
        this.$parent.$refs.changeGPSDialog.show();
      }
    },
    openQueryRunVersion(target) {
      this.$refs.queryRunVersionContent.queryRunVersionOne(target);
      this.$refs.queryRunVersionRef.show();
    },
    openQueryStoreVersion(target) {
      this.$refs.queryStoreVersionContent.queryStoreVersionOne(target);
      this.$refs.queryStoreVersionRef.show();
    },

    openDelDevice() {
      this.$refs.confirmDel.show();
    },
     closeDelDevice() {
      this.$refs.confirmDel.clear();
      this.$refs.confirmDel.close();
    },

    //关闭运行版本查询窗口
    closeQueryRunVersion() {
      this.$refs.queryRunVersionRef.clear();
      this.$refs.queryRunVersionRef.close();
    },
    //关闭存储版本查询窗口
    closeStoreRunVersion() {
      this.$refs.queryStoreVersionRef.clear();
      this.$refs.queryStoreVersionRef.close();
    },
  },
  created() {
    EventBus.$on("openQueryRunVersion", (target) => {
      this.openQueryRunVersion(target);
    });
    EventBus.$on("openQueryStoreVersion", (target) => {
      this.openQueryStoreVersion(target);
    });
  },
  // beforeDestroy() {
  //   socketInstance.stopReceiveTopicMsg(
  //     this.websocketSettingQuery[0].clientId,
  //     this.websocketSettingQuery[0].topic
  //   );
  // },
};
</script>

